export const refineTimer = ({ timer }) => {
  const getSeconds = `0${timer % 60}`.slice(-2);
  const minutes = `${Math.floor(timer / 60)}`;
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `0${Math.floor(timer / 3600)}`.slice(-2);
  const text = `${getHours}:${getMinutes}:${getSeconds}`;
  return text;
};

export const refineSpecificTimer = ({ timer }) => {
  const round = Math.round(timer);
  const getSeconds = `0${round % 60}`.slice(-2);
  const minutes = `${Math.floor(round / 60)}`;
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `0${Math.floor(round / 3600)}`.slice(-2);
  const text = `${getHours}h.${getMinutes}m.${getSeconds}s`;
  return text;
};

export const refineSpecificTimerSub = ({ timer }) => {
  const round = Math.round(timer);
  const getSeconds = `0${round % 60}`.slice(-2);
  const minutes = `${Math.floor(round / 60)}`;
  const getMinutes = `0${minutes % 60}`.slice(-2);
  const getHours = `0${Math.floor(round / 3600)}`.slice(-2);
  const text = `${getHours}:${getMinutes}:${getSeconds}`;
  return text;
};
